import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const services = [
  {
    id: 1,
    title: 'Roofing',
    description: 'Expert roofing installations, repairs, and replacements for residential and commercial properties.',
    link: '/roofing',
    img: 'https://firebasestorage.googleapis.com/v0/b/champion-building.appspot.com/o/IMG_0268.jpeg?alt=media&token=0d905203-c6e8-4038-abbc-33497f59c806',
  },
  {
    id: 2,
    title: 'Plumbing',
    description: 'Full-service plumbing solutions — from pipe installations to complete drainage systems.',
    link: '/plumbing',
    img: 'https://firebasestorage.googleapis.com/v0/b/champion-building.appspot.com/o/BD25BA26-B77F-419A-B5B8-7DF9AE152CDD.jpeg?alt=media&token=e364b784-6c7f-4807-b66a-5576a3b110f8',
  },
  {
    id: 3,
    title: 'Bathrooms',
    description: 'Complete bathroom remodels and renovations crafted with precision and quality materials.',
    link: '/bathrooms',
    img: 'https://firebasestorage.googleapis.com/v0/b/champion-building.appspot.com/o/image000007.jpeg?alt=media&token=33cc5b2b-dc44-46f6-b7a5-4c894d25ed07',
  },
  {
    id: 4,
    title: 'Framing',
    description: 'Structural framing services built to code with integrity and lasting durability.',
    link: '/framing',
    img: 'https://firebasestorage.googleapis.com/v0/b/champion-building.appspot.com/o/2009247747760568172.jpeg?alt=media&token=492d0424-5ce2-4934-b66d-625d71cb6cde',
  },
  {
    id: 5,
    title: 'Windows',
    description: 'Professional window installation and replacement to enhance energy efficiency and curb appeal.',
    link: '/windows',
    img: 'https://firebasestorage.googleapis.com/v0/b/tortas-bffc7.appspot.com/o/window%20work.jpg?alt=media&token=bee47445-2e02-4f99-8159-7e935b95434b',
  },
  {
    id: 6,
    title: 'Electricity',
    description: 'Safe and reliable electrical work from panel upgrades to full home wiring.',
    link: '/electricity',
    img: 'https://firebasestorage.googleapis.com/v0/b/champion-building.appspot.com/o/electricty%20work.jpeg?alt=media&token=4c67fe0f-e7d4-45da-8b79-4e0c179c1781',
  },
];

const ServicesGrid = () => {
  return (
    <Section>
      <Inner>
        <SectionHeader>
          <Eyebrow>What We Do</Eyebrow>
          <SectionTitle>Our Services</SectionTitle>
          <SectionSubtitle>
            From the roof to the foundation — we handle every aspect of your construction project
            with the quality and expertise your home deserves.
          </SectionSubtitle>
        </SectionHeader>
        <Grid>
          {services.map(service => (
            <Card key={service.id} to={service.link}>
              <CardImageWrap>
                <CardImage src={service.img} alt={service.title} />
              </CardImageWrap>
              <CardBody>
                <CardTitle>{service.title}</CardTitle>
                <CardText>{service.description}</CardText>
                <CardCta>
                  Learn More <FaArrowRight style={{ fontSize: '0.75rem' }} />
                </CardCta>
              </CardBody>
            </Card>
          ))}
        </Grid>
      </Inner>
    </Section>
  );
};

const Section = styled.section`
  padding: 96px 32px;
  background: #f9fafb;
  @media (max-width: 768px) {
    padding: 64px 20px;
  }
`;

const Inner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 64px;
`;

const Eyebrow = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #c89432;
  margin-bottom: 12px;
`;

const SectionTitle = styled.h2`
  font-family: "Poppins", sans-serif;
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  font-weight: 700;
  color: #111827;
  margin-bottom: 16px;
`;

const SectionSubtitle = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 1.05rem;
  color: #6b7280;
  max-width: 580px;
  margin: 0 auto;
  line-height: 1.7;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  }
`;

const CardImageWrap = styled.div`
  width: 100%;
  height: 220px;
  overflow: hidden;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
  ${Card}:hover & {
    transform: scale(1.06);
  }
`;

const CardBody = styled.div`
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CardTitle = styled.h3`
  font-family: "Poppins", sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 10px;
`;

const CardText = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.65;
  flex: 1;
  margin-bottom: 20px;
`;

const CardCta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: "Poppins", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: #c89432;
  transition: gap 0.25s ease;
  ${Card}:hover & {
    gap: 14px;
  }
`;

export default ServicesGrid;
